// extracted by mini-css-extract-plugin
export default {"infoContainer":"info_section_infoContainer__QdK9d","button":"info_section_button__tXcb1"};